import { render, staticRenderFns } from "./tblycb.vue?vue&type=template&id=67410b5c&scoped=true&"
import script from "./tblycb.vue?vue&type=script&lang=js&"
export * from "./tblycb.vue?vue&type=script&lang=js&"
import style0 from "./tblycb.vue?vue&type=style&index=0&id=67410b5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67410b5c",
  null
  
)

export default component.exports